<template>
    <div class="group h-full p-6 bg-slate-800/50 hover:bg-slate-800/80 border border-slate-800 hover:border-primary-500/50 rounded-2xl transition-all duration-300 hover:shadow-xl hover:shadow-primary-500/10 hover:-translate-y-1">
        <div class="flex items-start space-x-4">
            <div class="flex-shrink-0 p-3 bg-slate-900 rounded-xl group-hover:bg-slate-800 transition-colors border border-slate-700/50">
                <img class="h-8 w-8 object-contain" :src="tool.icon" :alt="tool.name + ' Logo'">
            </div>
            <div>
                <h3 class="font-semibold text-slate-100 group-hover:text-primary-400 transition-colors mb-1">{{ tool.name }}</h3>
                <p class="text-sm text-slate-400 line-clamp-2 leading-relaxed">{{ tool.description }}</p>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Tool } from '@/types/types';

export default defineComponent({
    name: 'ToolCard',
    props: {
        tool: {
            type: Object as () => Tool,
            required: true
        }
    }
});
</script>
